let Side = /* @__PURE__ */ function(Side$1) {
	Side$1[Side$1["left"] = -1] = "left";
	Side$1[Side$1["right"] = 1] = "right";
	return Side$1;
}({});
export { Side };

//# sourceMappingURL=index50.js.map